var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.selectedLayout,{tag:"component",attrs:{"subscription":_vm.mySubscriptionData,"configData":_vm.configData},on:{"subscription-clicked":_vm.subscriptionClicked}})}
var staticRenderFns = []

export { render, staticRenderFns }